import $ from 'jquery'

    $(document).on('click', '.js-modal-team-open', function(e) {
      e.preventDefault();
      var item = $(this).closest('.team-card');
      var item_data = item.data('modal-content');
      $('#teamMemberModal .team-modal-name ').html(item_data.name);
      $('#teamMemberModal .team-modal-text ').html(item_data.bio);
      $('#teamMemberModal').modal('show');
    });

    $('#teamMemberModal').on('hidden.bs.modal', function(e) {
      $('#teamMemberModal .team-modal-name ').html('');
      $('#teamMemberModal .team-modal-text ').html('');
    })
